const init = () => {
  const attachedFilesContainers = document.querySelectorAll('.goodscard-reviews__attached-files');

  if (attachedFilesContainers.length) {
    attachedFilesContainers.forEach((attachedFilesContainer) => {
      const attachedFiles = attachedFilesContainer.querySelectorAll('.goodscard-reviews__attached-file');
      const additionalFilesCounter = attachedFiles.length - 3;

      if (additionalFilesCounter > 0) {
        const elemWithBlur = attachedFiles[2];
        const innerLink = elemWithBlur.querySelector('.full-screen-viewer');

        if (innerLink) {
          const blurBlock = document.createElement('div');
          blurBlock.classList.add('blur-block');
          blurBlock.innerHTML = `+${additionalFilesCounter}`;
          elemWithBlur.classList.add('_with-blur');
          innerLink.prepend(blurBlock);
        }
      }
    });
  }
};

window.attachedFilesInit = init;
